import { useState, useEffect, useCallback } from 'react';
import { useMountedState } from 'react-use';
import { useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';

import { fetchLegalBasisTypes } from 'APIPackage/CatalogsModule/services/legalBasisApi';
import { ILegalBasisDocumentType } from 'APIPackage/CatalogsModule/interfaces/ILegalBasisDocumentType';
import { coreSetLoading } from 'CorePackage/MainModule/actions/coreActions';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';

import { ILegalBasisDocumentTypeSelectOption } from '../interfaces/ILegalBasisDocumentTypeSelectOption';

export function useLegalBasisTypes(isOn?: boolean) {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const isMounted = useMountedState();
  const [legalBasisDocumentTypes, setLegalBasisDocumentTypes] = useState<ILegalBasisDocumentType[]>([]);
  const [legalBasisDocumentTypesSelectOptions, setLegalBasisDocumentTypesSelectOptions] = useState<
    ILegalBasisDocumentTypeSelectOption[]
  >([]);

  const refresh = useCallback(async () => {
    try {
      dispatch(coreSetLoading(true));
      const types = await fetchLegalBasisTypes();

      isMounted() && setLegalBasisDocumentTypes(types);
    } finally {
      dispatch(coreSetLoading(false));
    }
  }, [dispatch, isMounted]);

  useEffect(() => {
    isOn && refresh();
  }, [isOn, refresh]);

  useEffect(() => {
    const options: ILegalBasisDocumentTypeSelectOption[] = legalBasisDocumentTypes.map(item => ({
      ...item,
      label: item.name,
      value: item.name,
    }));

    setLegalBasisDocumentTypesSelectOptions(options);
  }, [legalBasisDocumentTypes]);

  return {
    refresh,
    legalBasisDocumentTypes,
    legalBasisDocumentTypesSelectOptions,
  };
}
